import { Skeleton } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';

type LotteryCategoryResultsCountProps = {
  isLoading: boolean;
  resultsCount: number;
};

/**
 * LotteryCategoryResultsCount is shared component for results count for lottery categories.
 * While data is loading, it displays a skeleton animation.
 *
 * @param isLoading - Indicates whether the data is currently loading.
 * @param resultsCount - The number of results for the lottery category.
 * @returns The component's JSX representation.
 */
function LotteryCategoryResultsCount({ isLoading, resultsCount }: LotteryCategoryResultsCountProps) {
  const t = useTranslations('lotteries');
  return isLoading ? <Skeleton className="w-16 h-4.5" /> : t('categories_results', { number: resultsCount });
}

export { LotteryCategoryResultsCount };
